enum CarrotRoute {
  Home = "/",
  Submit = "/reimbursements/submit",
  Upload = "/reimbursements/upload",
  IvfRequirements = "/reimbursements/ivf-requirements",
  IvfRequirementsSigned = "/reimbursements/ivf-requirements-signed/"
}

enum CarrotQueryParam {
  ReimbursementType = "reimbursement-type",
  Signed = "signed"
}

const getReimbursementUrl = (
  route: CarrotRoute,
  expenseId: string = null,
  reimbursementType: string = null
): string => {
  let redirectUrl = route.valueOf()
  if (!!expenseId) {
    redirectUrl += `/${expenseId}`
  }
  if (!!reimbursementType) {
    redirectUrl += `?${CarrotQueryParam.ReimbursementType}=${reimbursementType}`
  }
  return redirectUrl
}

export { CarrotRoute, CarrotQueryParam, getReimbursementUrl }
